import { useState } from "react";
import { PROXY } from "../lib/utils";
import useAuth from "../hooks/useAuth";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Button } from "@material-tailwind/react";
import { IoTrashSharp } from "react-icons/io5";


const DeleteReviewModal = ({ onClose, showModal, mutate, courseId, reviewId }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { accessToken } = useAuth();
    const { t } = useTranslation();
    

    const handleDeleteReview = async () => {
        if (!reviewId) {
            toast.error(t("toast.review-delete-failed"), { position: "top-center" });
            return;
        }

        try {
            setIsLoading(true);
            const response = await fetch(`${PROXY}/courses/${courseId}/reviews/${reviewId}`, {
                method: "DELETE",
                headers: {
                    "Authorization": "Bearer " + accessToken,
                },
            });

            if (!response.ok) {
                throw new Error("Delete failed");
            }

            mutate();
            onClose();
            setIsLoading(false);
            toast.success(t("toast.review-delete-success"), { position: "top-center" });

        } catch (err) {
            console.log(err);
            setIsLoading(false);
            toast.error(t("toast.review-delete-failed"), { position: "top-center" });
        }
    }

    return (
        <div
            id="popup-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="delete-review-title"
            className={`fixed top-0 left-0 z-20 flex h-full w-full items-center justify-center p-4 ${showModal ? "" : "hidden"
                }`}
        >
            <div className="absolute h-full w-full bg-slate-950/60" onClick={onClose}></div>
            <div className="relative w-full max-w-md rounded-3xl bg-white p-6 shadow-xl">
                <div className="text-center">
                    <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-600">
                        <IoTrashSharp size={24} />
                    </div>
                    <h3 id="delete-review-title" className="mb-2 text-lg font-semibold text-slate-900">
                        {t("ReviewForm.DeleteTitle")}
                    </h3>
                    <p className="mb-6 text-sm leading-6 text-slate-600">
                        {t("ReviewForm.DeleteDescription")}
                    </p>
                    <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-center">
                        <Button
                            type="button"
                            variant="outlined"
                            color="blue-gray"
                            onClick={onClose}
                            className="rounded-full"
                        >
                            {t('Cancel')}
                        </Button>
                        <Button
                            type="button"
                            color="red"
                            onClick={handleDeleteReview}
                            disabled={isLoading}
                            className="rounded-full"
                        >
                            {isLoading ? t('Deleting') : t('ReviewForm.DeleteAction')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteReviewModal;
